import { useQuery, registerQuery } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
import { useMemo } from 'react';
// Standardizing the response to match A/B variants allows us to use the same UI
const makeVariantsList = pages => pages.map(({
  analyticsPageId,
  id,
  url,
  name,
  personalizationVariantStatus,
  personalizationStrategyId
}) => ({
  id: String(analyticsPageId) || String(id),
  name,
  url,
  pageId: id,
  personalizationVariantStatus,
  personalizationStrategyId
}));
const fetchPersonalizationVariants = ({
  contentId
}) => http.get(`cospages/v2/landing-pages/${contentId}/personalized-variants`).then(makeVariantsList);
const PersonalizationVariantsQuery = registerQuery({
  fieldName: 'personalizationVariants',
  args: ['contentId'],
  fetcher: fetchPersonalizationVariants
});
export const useFetchPersonalizationVariants = ({
  contentId,
  shouldFetchData
}) => {
  const {
    data,
    loading,
    error,
    refetch
  } = useQuery(PersonalizationVariantsQuery, {
    variables: {
      contentId
    },
    skip: !contentId || !shouldFetchData
  });
  return useMemo(() => ({
    personalizationVariants: data === null || data === void 0 ? void 0 : data.personalizationVariants,
    personalizationVariantsRequestError: error,
    personalizationVariantsRequestLoading: loading,
    refetchPersonalizationVariants: refetch
  }), [data, error, loading, refetch]);
};